import { useState } from 'react';

export default function CTASection() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);

    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('company_alt') as HTMLInputElement)?.value || '';
    if (honeypot.trim() !== '') {
      setSubmitted(true);
      setSubmitting(false);
      return;
    }

    const formData = new FormData(form);
    const name = (formData.get('name') as string || '').trim();
    const company = (formData.get('company') as string || '').trim();
    const phone = (formData.get('phone') as string || '').trim();
    const comment = (formData.get('comment') as string || '').trim();

    let cleanPhone = phone.replace(/[^\d+]/g, '');
    if (!cleanPhone.startsWith('+')) cleanPhone = '+' + cleanPhone;

    const baseUrl = 'https://businesstrainer.bitrix24.by/rest/1/yxbm0u72myjrxywc/crm.lead.add.json';
    const params = new URLSearchParams({
      'fields[NAME]': name,
      'fields[TITLE]': `Лид с businesstraining ${name}`,
      'fields[COMPANY_TITLE]': company,
      'fields[PHONE][0][VALUE]': cleanPhone,
      'fields[COMMENTS]': comment,
      'params[REGISTER_SONET_EVENT]': 'Y',
      'ASSIGNED_BY_ID': '1',
    });

    fetch(`${baseUrl}?${params.toString()}`, { method: 'GET' })
      .then(async (res) => {
        if (res.ok) {
          const result = await res.json();
          if (result.result) {
            setSubmitted(true);
            form.reset();
          } else {
            throw new Error('Ошибка отправки');
          }
        } else {
          throw new Error('Ошибка отправки');
        }
      })
      .catch(() => setError('Произошла ошибка. Попробуйте ещё раз.'))
      .finally(() => setSubmitting(false));
  };

  return (
    <section id="contact" className="py-20 md:py-28 bg-gradient-to-br from-teal-600 to-teal-700 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20elegant%20geometric%20pattern%20with%20soft%20overlapping%20circles%20and%20flowing%20lines%20in%20teal%20and%20white%20tones%20modern%20corporate%20background%20design%20minimal%20artistic%20texture%20sophisticated%20clean%20aesthetic&width=1920&height=800&seq=needs-cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover opacity-10"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
            Получите программу корпоративного тренинга по выявлению потребностей
          </h2>
          <p className="text-lg text-white/80 leading-relaxed">
            Помогу адаптировать обучение под ваши задачи, продукт, цикл сделки и уровень менеджеров.
          </p>
        </div>

        <div className="max-w-xl mx-auto">
          {submitted ? (
            <div className="bg-white/15 backdrop-blur-md rounded-2xl p-8 text-center border border-white/20">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-check-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-2">Спасибо за заявку!</h3>
              <p className="text-white/80">Я свяжусь с вами в ближайшее время, чтобы обсудить программу под ваши задачи.</p>
            </div>
          ) : (
            <form data-readdy-form onSubmit={handleSubmit} className="bg-white rounded-2xl p-6 md:p-8 shadow-xl">
              {error && (
                <div className="bg-red-50 text-red-600 text-sm rounded-lg p-3 mb-4">
                  {error}
                </div>
              )}
              <div className="space-y-4">
                <div>
                  <label htmlFor="na_name" className="block text-sm font-semibold text-gray-700 mb-1.5">Имя</label>
                  <input
                    type="text" id="na_name" name="name" required
                    className="w-full px-4 py-3 rounded-lg border border-gray-200 text-sm focus:border-teal-500 focus:ring-1 focus:ring-teal-500 outline-none transition-colors"
                    placeholder="Ваше имя"
                  />
                </div>
                <div>
                  <label htmlFor="na_company" className="block text-sm font-semibold text-gray-700 mb-1.5">Компания</label>
                  <input
                    type="text" id="na_company" name="company" required
                    className="w-full px-4 py-3 rounded-lg border border-gray-200 text-sm focus:border-teal-500 focus:ring-1 focus:ring-teal-500 outline-none transition-colors"
                    placeholder="Название компании"
                  />
                </div>
                <div>
                  <label htmlFor="na_phone" className="block text-sm font-semibold text-gray-700 mb-1.5">Телефон</label>
                  <input
                    type="tel" id="na_phone" name="phone" required
                    className="w-full px-4 py-3 rounded-lg border border-gray-200 text-sm focus:border-teal-500 focus:ring-1 focus:ring-teal-500 outline-none transition-colors"
                    placeholder="+375 (__) ___ __ __"
                  />
                </div>
                <div>
                  <label htmlFor="na_comment" className="block text-sm font-semibold text-gray-700 mb-1.5">Комментарий</label>
                  <textarea
                    id="na_comment" name="comment" rows={3} maxLength={500}
                    className="w-full px-4 py-3 rounded-lg border border-gray-200 text-sm focus:border-teal-500 focus:ring-1 focus:ring-teal-500 outline-none transition-colors resize-none"
                    placeholder="Опишите ваши задачи или вопросы"
                  ></textarea>
                  <p className="text-xs text-gray-400 mt-1">До 500 символов</p>
                </div>

                <div className="form-honeypot" aria-hidden="true">
                  <input
                    type="text"
                    name="company_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    readOnly
                    style={{ position: 'absolute', left: '-9999px', opacity: 0, height: 0, width: 0, pointerEvents: 'none' }}
                  />
                </div>

                <button
                  type="submit"
                  disabled={submitting}
                  className="w-full bg-teal-600 text-white px-6 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {submitting ? 'Отправка...' : 'Получить программу'}
                </button>
              </div>
              <p className="text-xs text-gray-400 text-center mt-4">
                Нажимая кнопку, вы соглашаетесь с обработкой персональных данных.
              </p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}